<template>
  <div :class="{'spl-message-modal-holder-show': isVisible}" class="spl-message-modal-holder">
    <div :class="{'spl-message-modal__success': messageType === 'Success'}" class="spl-message-modal">
      <!-- Success Header -->
      <div v-if="messageType === 'Success'" class="spl-message-modal__label">
        <img src="../../assets/icon-check.svg"> Wow {{ firstName }} great success...
      </div>

      <div class="spl-message-modal__content">
        {{ message }}
      </div>
      <form-button class="spl-next-button" @onClick="book_More">
        {{ bookingType === constants.BUS_KEYS.BOOK_SUCCESS_MODAL_TYPE_CONSOLIDATED ? 'Book another consolidated parcel' : 'Book another parcel' }}
      </form-button>
      <form-button
        v-if="bookingType === constants.BUS_KEYS.BOOK_SUCCESS_MODAL_TYPE_PARCEL"
        class="spl-next-button"
        @onClick="see_Parcel_Details">
        See the parcel details
      </form-button>
      <form-button
        v-if="bookingType === constants.BUS_KEYS.BOOK_SUCCESS_MODAL_TYPE_CONSOLIDATED"
        class="spl-next-button"
        @onClick="see_Consolidated_Bookings">
        Show parcel list
      </form-button>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'ParcelBookSuccessModal',
  data () {
    return {
      isVisible: false,
      messageType: '',
      message: '',
      bookingType: 'parcel',
      constants
    }
  },
  computed: {
    ...mapGetters('user', ['firstName'])
  },
  mounted () {
    // Success Modal
    window.bus.$on(constants.BUS_EVENTS.OPEN_BOOK_SUCCESS_MODAL, this.handleOpenBookSuccessModal)
  },

  beforeDestroy () {
    window.bus.$off(constants.BUS_EVENTS.OPEN_BOOK_SUCCESS_MODAL, this.handleOpenBookSuccessModal)
  },

  methods: {
    handleOpenBookSuccessModal (message, bookingType = 'parcel') {
      this.isVisible = true
      this.messageType = 'Success'
      this.message = message
      this.bookingType = bookingType
    },
    closeMessageModal () {
      this.isVisible = false
    },
    // Continue booking a new parcel
    book_More () {
      this.isVisible = false
      this.$emit('book_More_Clicked')
    },
    // Continue to the parcel details page
    see_Parcel_Details () {
      this.isVisible = false
      this.$emit('see_Parcel_Details_Clicked')
    },
    see_Consolidated_Bookings () {
      this.isVisible = false
      this.$emit('see_Consolidated_Bookings_Clicked')
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";
.spl-message-modal-holder {
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 90000;
  overflow: auto;

  &-show {
    display: block;
  }
  .spl-message-modal {
    left: 50%;
    padding: 20px 15px 30px 15px;
    position: absolute !important;
    top: 25%;
    transform: translate3d(-50%, 0, 0);
    width: 700px;

    @include mobile() {
      left: $mobilePadding;
      transform: translate3d(0, 0, 0);
      top: $mobilePadding;
      width: calc(100% - #{$mobilePadding*2});
    }
    &__error {
      background-color: $redBackground;
    }
    &__success {
      background-color: $grayBackground;
    }
    &__warning {
      background-color: $lightYellow;
    }
    &__info {
      background-color: $lightYellow;
    }
    &__label {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    &__close {
      background-image: url(../../assets/icon-close.svg);
      background-position: center center;
      background-repeat: no-repeat;
      cursor: pointer;
      height: 25px;
      position: absolute;
      right: 10px;
      top: 20px;
      transition: opacity $shortTransition ease-in-out;
      width: 25px;

      &:hover {
        opacity: 0.5;
      }
    }
    &__content {
      padding-bottom: 10px;
    }
    .spl-message-label {
      color: $parcelDetailBlockLabelColor;
    }
    .spl-message-button {
      margin-bottom: 0;
    }
  }
}
</style>
